module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "little"
  }, [_vm._v("Datos personales para consulta")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.isLoading) ? [_c('loading')] : [_c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.codigo,
      "title": "Codigo interno"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.dni,
      "title": "DNI"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.cargo,
      "title": "Cargo"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.email,
      "title": "Email de la empresa"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.fechaIngreso,
      "title": "Fecha de ingreso"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": ((_vm.empleadoPersonal.sueldoCuenta) + " " + (_vm.empleadoPersonal.sueldoNombreBanco) + " " + (_vm.empleadoPersonal.sueldoMoneda)),
      "title": "Cuenta Sueldo",
      "dangerMessage": "Recursos humanos debe especificar el dato"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": ((_vm.empleadoPersonal.ctsCuenta) + " " + (_vm.empleadoPersonal.ctsNombreBanco) + " " + (_vm.empleadoPersonal.ctsMoneda)),
      "title": "Cuenta CTS",
      "dangerMessage": "Recursos humanos debe especificar el dato"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleadoPersonal.tipoPension,
      "title": "Tipo pension",
      "dangerMessage": "Recursos humanos debe especificar el dato"
    }
  }), _c('datos-conjuntos', {
    attrs: {
      "model": _vm.empleado.regimen,
      "title": "Régimen",
      "capitalize": "capitalize",
      "dangerMessage": "General"
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-179e10aa","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Datos_Personales_Consulta.vue
// module id = 832
// module chunks = 0